module.exports = __webpack_public_path__ + "static/media/xiangmudingdan.df6be0c6.png";